export default __webpack_public_path__ + "static/media/vitalik_poap_18.ffea9872.svg";